<script>
  import Select from 'svelte-select';
  import Loader from '../Loader.svelte';
  import FormTextarea from '../FormControls/FormTextarea.svelte';
  import ProfileImg from '../../components/ProfileImage.svelte';
  import { client } from 'root/api/index.js';
  import { getContext, onMount } from 'svelte';
  import { Modal } from 'bootstrap';
  import { configItem } from '../../components/Helper';
  export let selectedUsers,
    selectedCollabratorUsers,
    form,
    errors,
    handleChange,
    handleSubmit,
    isFormPending,
    handleReasonSubmit;
  let editCollabratorModal;
  export const show = () => {
    editCollabratorModal = new Modal(document.getElementById('editCollabrator'), {
      backdrop: false,
      keyboard: false,
    });
    editCollabratorModal.show();
  };
  export const hide = () => {
    if (editCollabratorModal != undefined) {
      editCollabratorModal.hide();
    }
  };

  let reviewCollabratorModal;
  export const showReview = () => {
    reviewCollabratorModal = new Modal(document.getElementById('reviewCollabrator'), {
      backdrop: false,
      keyboard: false,
    });
    reviewCollabratorModal.show();
  };
  export const hideReview = () => {
    if (reviewCollabratorModal != undefined) {
      reviewCollabratorModal.hide();
    }
  };
  let undoCollabratorModal;
  export const showUndo = () => {
    undoCollabratorModal = new Modal(document.getElementById('undoCollabrator'), {
      backdrop: false,
      keyboard: false,
    });
    undoCollabratorModal.show();
  };
  export const hideUndo = () => {
    if (undoCollabratorModal != undefined) {
      undoCollabratorModal.hide();
    }
  };

  let isPaginationLoading = false;
  let taskLogData = [];
  const getHistoryList = () => {
    if ($form.id > 0) {
      isPaginationLoading = true;
      client
        .taskHistoryList(1000000, 1, {
          taskId: $form.id,
          comeFrom: 'collaboration',
        })
        .then((response) => {
          isPaginationLoading = false;
          taskLogData = response.data.payload;
        });
    }
  };
  onMount(() => {
    getHistoryList();
  });
  const showDialog = getContext('showDialog');
</script>

{#if $form.collabratorReviewStatus == 1 || taskLogData.length > 0}
  <div class="collabrator-activity">
    <div class="d-flex flex-row justify-content-between align-items-center">
      <span class="font-size-14 font-weight-500">Collaboration Activity</span>
      {#if $form.collabratorReviewStatus == 1}
        <div>
          <button
            type="button"
            on:click={() => {
              show();
            }}
            class="btn border-0 shadow-none btn-link font-size-12 m-0 p-0"
          >
            Change Collaborator
          </button>
          <button
            type="button"
            on:click={() => {
              showUndo();
            }}
            class="btn border-0 shadow-none btn-link font-size-12 m-0 p-0"
            style="border-left: 1px solid !important;padding-left: 3px !important;border-radius: 0;"
          >
            Undo Collaborator
          </button>
        </div>
      {/if}
      <!-- <button type="button" on:click={()=>{
		  showReview()
		}} class="btn border-0 shadow-none btn-link font-size-12 m-0 p-0">
		 Review Collaborator
		</button> -->
    </div>
    <hr />
    <div class="task-log">
      <ul class="position-relative">
        {#each taskLogData as itemData, itemkey}
          <li class="position-relative">
            <div class="d-flex flex-row">
              <div class="user-profile-img d-flex me-3">
                <ProfileImg
                  size={40}
                  photoUrl={itemData.user.photoUrl}
                  firstName={itemData.user.firstName}
                  lastName={itemData.user.lastName}
                />
              </div>
              <div class="w-100">
                <strong class="d-block font-weight-500"
                  >{itemData.user.firstName}
                  {itemData.user.lastName}</strong
                >
                <div class="d-flex flex-row justify-content-between">
                  <span class="d-block">{itemData.notes}.</span>
                  <small class="text-muted">
                    <img
                      alt=""
                      class="me-1 icon-14"
                      src="/images/clock.svg"
                    />
                    <span>{itemData.timeAgoStr}</span></small
                  >
                </div>
                <span class="d-block"
                  >{itemData.message.trim() == '' ? '' : 'Notes: '}{itemData.message}</span
                >
              </div>
            </div>
          </li>
        {/each}
      </ul>
    </div>
  </div>
{/if}
<!-- Modal -->
<div
  class="modal fade"
  id="editCollabrator"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  tabindex="-1"
  aria-labelledby="staticBackdropLabel"
  aria-hidden="true"
>
  <div class="modal-dialog shadow">
    <div class="modal-content">
      <div class="modal-header bg-transparent">
        <h5
          class="modal-title"
          id="staticBackdropLabel"
        >
          Change Collaborator
        </h5>
        <button
          type="button"
          class="btn-close"
          on:click={hide}
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body modal-body-height p-3">
        <div class="form-group mb-3 position-relative">
          <label
            for=""
            class="form-label">Select Collaborator</label
          >
          <Select
            showChevron={true}
            isClearable={true}
            bind:selectedValue={selectedCollabratorUsers}
            on:select={(ev) => {
              $form.collabratorUserId = ev.detail.userId;
            }}
            containerClasses="form-control"
            getSelectionLabel={(option) => {
              return option.firstName + ' ' + option.lastName;
            }}
            optionIdentifier="userId"
            getOptionLabel={(option) => {
              return option.firstName + ' ' + option.lastName;
            }}
            items={selectedUsers.filter((item) => {
              return item.active == 1;
            })}
          ></Select>
        </div>
        <div class="form-group mb-3 position-relative">
          <FormTextarea
            label="Collaborator Notes"
            placeholder="Enter Collaborator Notes"
            handleChange={handleChange}
            error={$errors.collabratorSubmitNotes}
            name="collabratorSubmitNotes"
            bind:value={$form.collabratorSubmitNotes}
            maxLength={configItem.maxLength.description}
          />
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="trans-btn my-0 mx-3 px-4 font-size-12 outline-0 btn-cancel font-size-12"
          on:click={hide}>Cancel</button
        >
        <button
          type="button"
          color="primary"
          class="btn btn-primary shadow-none background-blue mb-0 text-white add-task px-4 font-size-12"
          on:click={() => {
            $form.collabratorReviewStatus = 1;
            handleReasonSubmit();
          }}
          disabled={isFormPending}
        >
          {#if isFormPending}
            <Loader />
          {:else}
            <span class="color-white font-size-12 font-weight-400"> Save </span>
          {/if}
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="reviewCollabrator"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  tabindex="-1"
  aria-labelledby="staticBackdropLabel"
  aria-hidden="true"
>
  <div class="modal-dialog shadow">
    <div class="modal-content">
      <div class="modal-header bg-transparent">
        <h5
          class="modal-title"
          id="staticBackdropLabel"
        >
          Collaborator Review Back
        </h5>
        <button
          type="button"
          class="btn-close"
          on:click={hideReview}
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body modal-body-height p-3">
        <div class="form-group mb-3 position-relative">
          <FormTextarea
            label="Collaborator Review Back Notes"
            placeholder="Enter Notes..."
            handleChange={handleChange}
            error={$errors.collabratorReviewNotes}
            name="collabratorReviewNotes"
            bind:value={$form.collabratorReviewNotes}
            maxLength={configItem.maxLength.description}
          />
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="trans-btn my-0 mx-3 px-4 font-size-12 outline-0 btn-cancel font-size-12"
          on:click={hideReview}>Cancel</button
        >
        <button
          type="button"
          color="primary"
          class="btn btn-primary shadow-none background-blue mb-0 text-white add-task px-4 font-size-12"
          on:click={() => {
            $form.collabratorReviewStatus = 2;
            handleSubmit();
          }}
          disabled={isFormPending}
        >
          {#if isFormPending}
            <Loader />
          {:else}
            <span class="color-white font-size-12 font-weight-400"> Save </span>
          {/if}
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="undoCollabrator"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  tabindex="-1"
  aria-labelledby="staticBackdropLabel"
  aria-hidden="true"
>
  <div class="modal-dialog shadow">
    <div class="modal-content">
      <div class="modal-header bg-transparent">
        <h5
          class="modal-title"
          id="staticBackdropLabel"
        >
          Undo Collaborator
        </h5>
        <button
          type="button"
          class="btn-close"
          on:click={hideUndo}
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body modal-body-height p-3">
        <div class="form-group mb-3 position-relative">
          <FormTextarea
            label="Notes"
            placeholder="Enter Notes..."
            handleChange={handleChange}
            error={$errors.collabratorReviewNotes}
            name="collabratorReviewNotes"
            bind:value={$form.collabratorReviewNotes}
            maxLength={configItem.maxLength.description}
          />
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="trans-btn my-0 mx-3 px-4 font-size-12 outline-0 btn-cancel font-size-12"
          on:click={hideUndo}>Cancel</button
        >
        <button
          type="button"
          color="primary"
          class="btn btn-primary shadow-none background-blue mb-0 text-white add-task px-4 font-size-12"
          on:click={() => {
            $form.collabratorRemove = 1;
            handleSubmit();
          }}
          disabled={isFormPending}
        >
          {#if isFormPending}
            <Loader />
          {:else}
            <span class="color-white font-size-12 font-weight-400"> Save </span>
          {/if}
        </button>
      </div>
    </div>
  </div>
</div>

<style lang="scss">
  .collabrator-activity {
    background-color: $silver-color;
    margin-left: -16px;
    margin-right: -16px;
    padding: 16px;
  }
</style>
